import WithdrawalReceipt from "./WithdrawalReceipt";

export default WithdrawalReceipt;
